import {MobileDatePicker} from '@mui/x-date-pickers/MobileDatePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {Box} from '@mui/material';
import {getLocaleFromLang} from '../../../core/utilities/Utilities.js';
import dayjs from 'dayjs';
import {DefaultConfig,evaluateReadOnly} from '../../../core/utilities/Utilities';
import "dayjs/locale/en";
import "dayjs/locale/fi";
import "dayjs/locale/pt-br";
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldDate=({row,fieldName,application,recordRules,readOnly,setFieldValue})=>{
    const lang=application.globalData.lang;
    const locale=application.globalData.locale||lang;
    dayjs.locale(locale.toLowerCase());
    const fieldProp=row?.[fieldName];
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    const localeText=getLocaleFromLang(lang);

    return (
        <Box sx={{flex:1,minWidth:0}}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale.toLowerCase()} localeText={localeText}>
                <MobileDatePicker
                    sx={{width:'100%',marginTop:"0px",marginBottom:"0px","& .MuiPickersInputBase-root":{backgroundColor:readOnlyEvaluated?readOnlyBackgroundColor:""}}}
                    readOnly={readOnlyEvaluated}
                    displayWeekNumber={true}
                    slotProps={{
                        actionBar:{actions:['accept','cancel','clear','today']},
                        textField:{
                            required:fieldProp?.required?fieldProp?.required:false,
                            margin:"normal",
                            size:"small",
                            variant:"outlined",
                            error:fieldProp?.validation_error?fieldProp?.validation_error:false,
                            helperText:fieldProp?.validation_error_message?fieldProp?.validation_error_message:'',
                        }}}
                    label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
                    value={row[fieldName]?.value?dayjs(row[fieldName].value):null}
                    onChange={(newValue)=>{
                        const formattedDate=newValue?dayjs(newValue).format("YYYY-MM-DD"):null;
                        setFieldValue(fieldName,formattedDate);
                    }}
                />
            </LocalizationProvider>
        </Box>
    );
}

export default FieldDate;
